import React, { Component } from 'react';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Paper, Typography, Switch, FormControlLabel } from '@mui/material';
import { validateEmail, validatePassword } from '../helpers/utils';
import {
    CognitoUser,
    CognitoUserAttribute,
    AuthenticationDetails
} from "amazon-cognito-identity-js";
import { postJson } from '../helpers/RequestsHelper';
const moment = require('moment-timezone');

const containerStyle = {
    display: 'flex',
    alignSelf: 'center',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '400px',
    minHeight: '550px',
    maxHeight: '1100px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    margin: 'auto',
    overflow: 'auto'
}
const modalStyle = {
    // position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    height: '100%',
    overflow: 'auto'
}
const headerStyle = {
    flexDirection: 'column',
    width: '100%',
    maxWidth: '400px',
    maxHeight: '200px',
    minHeight: '100px',
    bgcolor: 'background.paper',
}
const bodyStyle = {
    flexDirection: 'column',
    width: '100%',
    maxWidth: '400px',
    maxHeight: '500px',
    minHeight: '250px',
    bgcolor: 'background.paper',
}
const tailStyle = {
    display: 'flex',
    flexDirection: 'column-reverse',
    width: '100%',
    maxWidth: '400px',
    maxHeight: '400px',
    minHeight: '250px',
    bgcolor: 'background.paper',
}
const rowStyle = {
    display: 'flex',
    flexDirection: 'row',
    flex: 1, 
    width: '100%',
    maxWidth: '400px',
    maxHeight: '400px',
    bgcolor: 'background.paper',
}
const boxStyle = {
    flexDirection: 'column',
    flex: 1, 
    flexGrow: 4,
    width: '100%',
    maxWidth: '400px',
    minHeight: '300px',
    maxHeight: '600px',
    bgcolor: 'background.paper',
}

class AuthFlow extends Component {

    state = {
        data: undefined,
        title: undefined,
        subtitle: undefined,
        quickSignup: false,
        email: undefined,
        password: undefined,
        temporaryPassword: undefined,
        fname: undefined,
        lname: undefined,
        marketingEmails: true,
        code: undefined,
        signedUp: false,
        confirmed: false,
        authenticated: false,
        forgotPassword: false,
        codeSent: false,
        modal: false,
        modalOpen: false,
        error: undefined,
        onAuthenticated: undefined,
        currentView: "signup",
        message: "",
        isError: false,
        timer: 10
    }

    constructor(parent) {
        super(parent)

        this.state.title = parent.props.title? parent.props.title : "Welcome to Simply Flows"
        this.state.subtitle = parent.props.subtitle? parent.props.subtitle : ""
        this.state.email = parent.props.email? parent.props.email : undefined
        this.state.modal = parent.props.modal? parent.props.modal : false
        this.state.modalOpen = parent.props.modalOpen? parent.props.modalOpen : false
        this.state.quickSignup = parent.props.quickSignup? parent.props.quickSignup : false

        this.tickTock = this.tickTock.bind(this)
        this.quickSignup = this.quickSignup.bind(this)
        this.fullSignup = this.fullSignup.bind(this)
        this.authenticate = this.authenticate.bind(this)
        this.onAuthSuccess = this.onAuthSuccess.bind(this)
        this.onAuthFail = this.onAuthFail.bind(this)
        this.sendCode = this.sendCode.bind(this)
        this.handleCodeSent = this.handleCodeSent.bind(this)
        this.confirmRegistrationCode = this.confirmRegistrationCode.bind(this)
        this.handleCodeConfirmed = this.handleCodeConfirmed.bind(this)
        this.resetPassword = this.resetPassword.bind(this)
        this.setError = this.setError.bind(this)
        this.confirmPassword = this.confirmPassword.bind(this)
        this.closeSignupModal = this.closeSignupModal.bind(this)
        this.emailChange = this.emailChange.bind(this)
        this.passwordChange = this.passwordChange.bind(this)
        this.onKeyUp = this.onKeyUp.bind(this)
        this.setMessage = this.setMessage.bind(this)


        this.state.onAuthenticated = parent.props.onAuthenticated? parent.props.onAuthenticated : this.closeSignupModal
        this.state.closeModal = parent.props.closeModal? parent.props.closeModal : () => {}

        if(!this.state.email && !parent.props.email) {
            let storedEmail = localStorage.getItem("signup_email")
            if(this.stringIsValid(storedEmail)) {
                this.state.email = storedEmail
            }
        }
    }

    componentDidUpdate(newProps) {
        if(newProps.props.modalOpen != this.state.modalOpen) {
            // console.log(newProps.props.data)
            this.setState({
                data: newProps.props.data, 
                email: newProps.props.email,
                quickSignup: newProps.props.quickSignup, 
                modal: newProps.props.modal,
                modalOpen: newProps.props.modalOpen,
                title: newProps.props.title,
                subtitle: newProps.props.subtitle,
                onAuthenticated: newProps.props.onAuthenticated? newProps.props.onAuthenticated : this.closeSignupModal,
                closeModal: newProps.props.closeModal? newProps.props.closeModal : () => {}
            })
        }

        if(!this.state.email && !newProps.props.email) {
            let storedEmail = localStorage.getItem("signup_email")
            if(this.stringIsValid(storedEmail)) {
                // console.log("GETTING STORED EMAIL", storedEmail)
                this.setState({ email: storedEmail })
            }
        }
    }

    //#region CONTROL

    submit = () => {}

    onKeyUp(e) {
        if (e.key === "Enter") {
            let field = e.target.name
            let value = e.target.value
            // console.log(field, value, typeof value, this.stringIsValid(value), validateEmail(value))
            if(this.stringIsValid(value)) {
                if(field === "email") {
                    if(validateEmail(value)) {
                        this.submit()
                    }
                } else if(field === "code" || field === "password") {
                    this.submit()
                }
            }
        }
    }

    stringIsValid(str) {
        if(str === undefined) {
            return false
        } else if(str === null) {
            return false
        } else if(str === "") {
            return false
        } else {
            return true
        }
    }
    
    setMessage(isError, code, message) {
        console.log(isError, code, message)
        if(isError) {
            if(!code) {
                message = "Error."
            } else if(code === "NotAuthorizedException") {

            } else if(code === "UsernameExistsException") {
                
            } else if(code === "InvalidParameterException") {
                message = "Incorrect value provided."
            }
        } else {
            if(!code) {
                message = "Success."
            } 
        }
        this.setState({message, isError})
    }

    setError(error) {
        // console.log("ERROR", error.code, error.message)

        this.setMessage(true, error.code, error.message)
    }

    emailChange(e) {
        this.setState({email: e.target.value})
        localStorage.setItem("signup_email", e.target.value)
        let emailValid = validateEmail(e.target.value)
        this.setMessage(!emailValid, "ValidEmail", emailValid? "Thank you for providing a valid email." : "Please enter a valid email.")
    }

    passwordChange(e) {        
        this.setState({password: e.target.value})
        let passwordValid = validatePassword(e.target.value)
        this.setMessage(!passwordValid, "ValidPassword", passwordValid? "Thank you for providing a valid password." : "Password must be 8 characters long and include: a number, a lowercase letter, and an uppercase letter.")
    }

    async tickTock() {
        if(this.state.timer === 0 && this.state.codeSent) {
            this.setState({codeSent: false})
        } else {
            this.setState({timer: this.state.timer - 1})
            await setTimeout(this.tickTock, 1000)
        }
    }

    closeSignupModal() {
        console.log("CLOSING MODAL")
        this.reset()
        this.state.closeModal()
    }

    reset() {
        this.setState({
            data: undefined,
            title: undefined,
            quickSignup: false,
            email: undefined,
            password: undefined,
            fname: undefined,
            lname: undefined,
            marketingEmails: true,
            temporaryPassword: undefined,
            code: undefined,
            signedUp: false,
            confirmed: false,
            authenticated: false,
            forgotPassword: false,
            codeSent: false,
            modal: false,
            modalOpen: false,
            error: undefined,
            onAuthenticated: undefined,
            currentView: "signup",
            message: "",
            isError: false,
            timer: 10
        })
    }

    generateTemporaryPassword() {
        var types = {
            0: "0123456789",
            1: "abcdefghijklmnopqrstuvwxyz",
            2: "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
        }

        var passwordLength = 10
        var temporaryPassword = "aA1"

        for (var i = 0; i <= passwordLength - 3; i++) {
            var randomType = Math.floor(Math.random() * 3);
            var randomNumber = Math.floor(Math.random() * types[randomType].length);
            temporaryPassword += types[randomType].substring(randomNumber, randomNumber + 1);
        }

        return temporaryPassword
    }

    async quickSignup() {
        const trimEmail = this.state.email.trim()
        const temporaryPassword = this.generateTemporaryPassword()

        const attributeList = [
            new CognitoUserAttribute({
                Name: 'email',
                Value: trimEmail
            }),
            new CognitoUserAttribute({
                Name: 'zoneinfo',
                Value: moment.tz.guess()
            })
        ]

        localStorage.setItem("signup_email", trimEmail)

        window.userPool.signUp(trimEmail, temporaryPassword, attributeList, null, () => this.authenticate())

        this.setState({temporaryPassword, codeSent: true})
        this.setMessage(false, "CodeSent", "Confirmation code has been sent.")
        await setTimeout(this.tickTock, 1000)

    }

    async fullSignup() {
    
        const trimEmail = this.state.email.trim()
        const password = this.state.password.trim()
        const attributeList = [
            new CognitoUserAttribute({
                Name: 'email',
                Value: trimEmail
            }),
            new CognitoUserAttribute({
                Name: 'given_name',
                Value: this.state.fname.trim()
            }),
            new CognitoUserAttribute({
                Name: 'family_name',
                Value: this.state.lname.trim()
            }),
            new CognitoUserAttribute({
                Name: 'custom:marketing_email',
                Value: this.state.marketingEmails ? "true" : "false"
            }),
            new CognitoUserAttribute({
                Name: 'zoneinfo',
                Value: moment.tz.guess()
            })
        ]

        console.log(this.state, attributeList)

        localStorage.setItem("signup_email", trimEmail)

        window.userPool.signUp(trimEmail, password, attributeList, null, () => this.authenticate())

        this.setState({codeSent: true})
        this.setMessage(false, "CodeSent", "Confirmation code has been sent.")
        await setTimeout(this.tickTock, 1000)

    }

    async authenticate() {
        var authenticationDetails = new AuthenticationDetails({
            Username: this.state.email,
            Password: this.state.password? this.state.password : this.state.temporaryPassword,
        })
        var userData = {
            Username: this.state.email,
            Pool: window.userPool,
        }
        var cognitoUser = new CognitoUser(userData)
        // console.log("AUTHENTICATING", authenticationDetails)
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: this.onAuthSuccess,
            onFailure: this.onAuthFail,
        })
    }

    async onAuthSuccess(result) {
        // console.log("AUTHENTICATION SUCCESS", result, this.state.onAuthenticated)
        this.setMessage(false)
        this.state.onAuthenticated()
        await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/updateProfile", { newUser: true });
    }

    async onAuthFail(err) {
        // console.log("AUTHENTICATION ERROR", err)
        if(err.code === "UserNotConfirmedException") {
            this.setState({signedUp: true, confirmed: false, authenticated: false})
            
            this.setError(err)
        } else if(err.code === "UsernameExistsException") {
            this.setState({signedUp: true, confirmed: true, authenticated: false})

            this.setMessage(false, err.code, err.message)
        } else if(err.code === "NotAuthorizedException") {
            this.setState({signedUp: true, confirmed: true, authenticated: false})

            this.setError(err)
        } 
    }

    async sendCode() {
        // console.log("SENDING CODE")
        var cognitoUser = new CognitoUser({
            Username: this.state.email,
            Pool: window.userPool,
        })
    
        cognitoUser.resendConfirmationCode(this.handleCodeSent)
    }

    async handleCodeSent(result, err) {
        // console.log("CODE SENT", err, result)
        if (err) {
            this.setError(err) 
            return
        } else {
            this.setMessage(false, "CodeSent", "Verification code has been sent.")
        }
        
        this.setState({codeSent: true, timer: 10})   
        await setTimeout(this.tickTock, 1000)
    }

    async confirmRegistrationCode() {
        // console.log("CONFIRMING CODE")

        var cognitoUser = new CognitoUser({
            Username: this.state.email,
            Pool: window.userPool,
        })
    
        cognitoUser.confirmRegistration(this.state.code, true, this.handleCodeConfirmed)
    }

    async handleCodeConfirmed(err, result) {
        // console.log("CODE CONFIRMED", err, result)

        if (err) {
            this.setError(err) 
            return
        } else {
            this.setMessage(false, "CodeConfirmed", "Verification code has been confirmed.")
        }

        this.authenticate() 
    }

    async resetPassword() {
        var userData = {
            Username: this.state.email,
            Pool: window.userPool,
        }
    
        var cognitoUser = new CognitoUser(userData)

        this.setState({forgotPassword: true})
        
        cognitoUser.forgotPassword({ 
            onSuccess: this.handleCodeSent,
            onFailure: this.setError
        })
    }

    async confirmPassword() {
        
        var cognitoUser = new CognitoUser({
            Username: this.state.email,
            Pool: window.userPool,
        })

        cognitoUser.confirmPassword(this.state.code, this.state.password, {
            onSuccess: this.authenticate,
            onFailure: this.setError
        })
    }

    //#endregion 

    //#region VIEW

    render() {
        return this.state.modal? (this.state.modalOpen? this.signupModalView() : null) : this.signupPageView()
    }
    
    signupModalView() {
        return (
            <Modal
                open={this.state.modalOpen}
                onClose={this.closeSignupModal}
            >
                {this.state.quickSignup? 
                    (!this.state.signedUp?
                        this.quickSignupView() :
                        (!this.state.confirmed? 
                            this.confirmSignupView() :
                            (!this.state.forgotPassword? 
                                this.logInView() : 
                                this.forgottenPasswordView()
                            )
                        )
                    ) : 
                    (!this.state.signedUp?
                        this.fullSignupView() :
                        (!this.state.confirmed? 
                            this.confirmSignupView() :
                            (!this.state.forgotPassword? 
                                this.logInView() : 
                                this.forgottenPasswordView()
                            )
                        )
                    )
                }
            </Modal>
        )
    }
    
    signupPageView() {
        return (
            this.state.quickSignup? 
                (!this.state.signedUp?
                    this.quickSignupView() :
                    (!this.state.confirmed? 
                        this.confirmSignupView() :
                        (!this.state.forgotPassword? 
                            this.logInView() : 
                            this.forgottenPasswordView()
                        )
                    )
                ) : 
                (!this.state.signedUp?
                    this.fullSignupView() :
                    (!this.state.confirmed? 
                        this.confirmSignupView() :
                        (!this.state.forgotPassword? 
                            this.logInView() : 
                            this.forgottenPasswordView()
                        )
                    )
                )
        )
    }

    quickSignupView() {
        this.submit = this.quickSignup
        return (
            <Box sx={containerStyle}>
                <Box sx={headerStyle}>
                    {this.headerView("header")}
                </Box>
                <Box sx={bodyStyle}>
                    {this.emailView("email")}
                </Box>
                <Box sx={tailStyle}>
                    {this.buttonView({id: "submit", onClick: this.submit, disabled: this.state.email === "" || this.state.email === undefined? true : !validateEmail(this.state.email)})}
                    <br />                    
                    {this.messageView("error")}
                </Box>
            </Box>
        )
    }
    
    fullSignupView() {
        this.submit = this.fullSignup
        return (
            <Box sx={containerStyle}>
                <Box sx={headerStyle}>
                    {this.headerView("header")}
                </Box>
                <Box sx={bodyStyle}>
                    {this.emailView("email")}
                    <br />
                    {this.passwordView("password")}
                    <br />
                    <Box sx={rowStyle}>
                        {this.nameView("fname", false)}
                        <div style={{height: '100%', width: '17px'}} />
                        {this.nameView("lname", true)}
                    </Box>
                    <br />
                    {this.radioView("radio")}
                    <br />
                    {this.termsAndPrivacy()}
                </Box>
                <Box sx={tailStyle}>
                    {this.buttonView({
                        id: "submit", onClick: this.submit, 
                        text: "Sign up",
                        disabled: 
                            this.stringIsValid(this.state.email) && 
                            this.stringIsValid(this.state.password) && 
                            validateEmail(this.state.email) && 
                            validatePassword(this.state.password)  
                            ? false : true 
                    })}
                    <br />          
                    {this.buttonView({id: "login", secondary: true, text: "Log in", onClick: () => this.setState({signedUp: true, confirmed: true}) })}
                    <br />          
                    {this.messageView("error")}
                </Box>
            </Box>
        )
    }

    confirmSignupView() {
        this.submit = this.confirmRegistrationCode
        return (
            <Box sx={containerStyle}>
                <Box sx={headerStyle}>
                    {this.headerView("header")}
                </Box>
                <Box sx={bodyStyle}>
                    {this.emailView("email", true)}
                    <br />
                    {this.codeView("code")}
                </Box>
                <Box sx={tailStyle}>
                    {this.buttonView({id: "submit", onClick: this.submit, disabled: !this.state.code })}
                    <br />
                    {this.buttonView({id: "resend", secondary: true, onClick: this.sendCode, disabled: this.state.codeSent, text: (!this.state.codeSent? "Resend Code" : this.state.timer) })}
                    <br />                    
                    {this.messageView("error")}
                </Box>
            </Box>
        )
    }

    logInView() {
        this.submit = this.authenticate
        return (
            <Box sx={containerStyle}>
                <Box sx={headerStyle}>
                    {this.headerView("header")}
                </Box>
                <Box sx={bodyStyle}>
                    {this.emailView("email", true)}
                    <br />
                    {this.passwordView("password")}
                </Box>
                <Box sx={tailStyle}>
                    {this.buttonView({id: "submit", onClick: this.submit, 
                        disabled: validateEmail(this.state.email)? (this.stringIsValid(this.state.password)? false : true) : true})}
                    <br />
                    {this.buttonView({id: "forgotPassword", secondary: true, onClick: this.resetPassword, text: "Set up or reset password?"})}
                    <br />     
                    {this.buttonView({id: "signup", onClick: () => this.setState({signedUp: false}), text: "Sign up"})}
                    <br />               
                    {this.messageView("error")}
                </Box>
            </Box>
        )
    }

    forgottenPasswordView() {
        this.submit = this.confirmPassword
        return (
            <Box sx={containerStyle}>
                <Box sx={headerStyle}>
                    {this.headerView("header")}
                </Box>
                <Box sx={bodyStyle}>
                    {this.emailView("email", true)}
                    <br />
                    {this.codeView("code")}
                    <br />
                    {this.passwordView("password")}
                </Box>
                <Box sx={tailStyle}>
                    {this.buttonView({ id: "submit", onClick: this.submit, disabled: this.state.code && this.state.password? false : true, text: "Confirm Password" })}
                    <br />
                    {this.buttonView({ id: "forgotPassword", secondary: true, onClick: this.resetPassword, disabled: this.state.codeSent, text: (!this.state.codeSent? "Resend Code" : this.state.timer) })}
                    <br />                    
                    {this.messageView("error")}
                </Box>
            </Box>
        )
    }

    headerView(key) {
        return (
            <Box key={"email_box_" + key}>
                <h4 id={key}>{this.state.title}</h4>
                <Typography>{this.state.subtitle}</Typography>
            </Box>
        )
    }

    emailView(key, disabled) {
        return( 
            <Box key={"email_box_" + key}>
                <Typography>Email</Typography>
                <input className="form-control w-400 validate-input"
                    type="email"
                    name="email"
                    autoComplete="email"
                    id={"email_input_" + key}
                    disabled={disabled? true : false}
                    value={this.state.email? this.state.email : ""}
                    onKeyUp={this.onKeyUp}
                    onChange={this.emailChange} />
            </Box>
        )
    }

    nameView(key, last) {
        return( 
            <Box key={"name_box_" + key}>
                <Typography>{last? "Last Name" : "First Name"}</Typography>
                <input className="form-control w-400 validate-input"
                    type="text"
                    name={last? "lname" : "fname"}
                    autoComplete="name"
                    id={"name_input_" + key}
                    value={ last? (this.state.lname? this.state.lname : "") : (this.state.fname? this.state.fname : "") }
                    onChange={(e) => this.setState( last? {lname: e.target.value} : {fname: e.target.value} )} 
                />
            </Box>
        )
    }

    radioView(key) {
        return( 
            <Box key={"name_box_" + key}>
                <FormControlLabel 
                    control={
                        <Switch 
                            checked={this.state.marketingEmails} 
                            onChange={(e) => this.setState({marketingEmails: e.target.checked})} 
                        />
                    } 
                    label="I would like to receive occasional emails with new features and tips." 
                />
            </Box>
        )
    }

    codeView(key) {
        return (
            <Box key={"code_box_" + key}>
                <Typography>Verification Code</Typography>
                <input className="form-control w-400"
                    type="code"
                    name="code"
                    autoComplete="code"
                    id={"code_input_" + key}
                    autoFocus 
                    value={this.state.code}
                    onKeyUp={this.onKeyUp}
                    onChange={(e) => this.setState({ code: e.target.value })} />
            </Box>
        )
    }

    passwordView(key) {
        return (
            <Box key={"password_box_" + key}>
                <Typography>Password</Typography>
                <input className="form-control w-400"
                    type="password"
                    name="password"
                    autoComplete="new-password"
                    required
                    minLength="8"
                    title="Password must be 8 characters long and include: a number, a lowercase letter, and an uppercase letter."
                    pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,99}"
                    id={"password_input_" + key}
                    autoFocus 
                    onKeyUp={this.onKeyUp}
                    onChange={this.passwordChange} />
            </Box>
        ) 
    }

    buttonView(props) {
        return (
            <Box key={"button_box_" + props.id + props.text}>
                <button className={props.secondary? "submit-btn-2 w-400" : "submit-btn w-400"}
                    key={"button_button_" + props.id + props.text}
                    onClick={props.onClick? props.onClick : () => {}} 
                    disabled={props.disabled? props.disabled : false}
                >{props.text? props.text : "Submit"}</button>
            </Box>
        )
    }

    messageView(key) {
        return (
            <Box key={"error_box_" + key}>
                {this.state.isError? 
                    <Typography sx={{fontSize: '14px', color: 'red'}}>{this.state.message? this.state.message : ""}</Typography> : 
                    <Typography sx={{fontSize: '14px', color: 'green'}}>{this.state.message? this.state.message : ""}</Typography> 
                }
            </Box>
        )
    }

    termsAndPrivacy() {
        return (
            <div>
                <p>
                    {"By creating an account, you agree to our "}
                    <a target="_blank" href={"https://simplyflows.com/terms/"}>Terms</a>
                    {" and "}
                    <a target="_blank" href={"https://simplyflows.com/privacy-policy/"}>Privacy</a>
                    {" policies."}
                </p>
            </div>
        )
    }

    //#endregion
}

export default AuthFlow